/**
 * Tenant-configurable permission override rules.
 *
 * Add a row here when introducing a permission whose grant list depends on org
 * settings. `OrgPolicyInput` derives from `Organization`, so a new field needs
 * no registration to be visible to `when()`; add a Site Settings control so
 * tenants can set it. See docs/authz.md How-to.
 *
 * Read `uses*` for access decisions only in `when()` — not in nav, pages, or
 * route manifests. Do not branch on organization name, code, or ID.
 */
import permissions from "@utils/permissions";

import type { OrgPolicyOverrideRule } from "./orgPolicy";

export const ORG_POLICY_OVERRIDE_RULES: readonly OrgPolicyOverrideRule[] = [
  {
    permissionId: "catalog.archive.read",
    when: (org) => org.usesItemArchive === false,
    roles: permissions.admin,
  },
];
